import { TS_BonuscardOrder }    from '../TravelSeller/Models/TS_BonuscardOrder';
import { BookingItemInterface } from './BookingItemInterface';

export class BonuscardOrder extends TS_BonuscardOrder implements BookingItemInterface {
    
}